(() => {
  const THUMB_QUALITIES = ['maxresdefault', 'sddefault', 'hqdefault', 'mqdefault'];

  const getQualityIndex = (quality) => {
    const index = THUMB_QUALITIES.indexOf(quality);
    return index === -1 ? 0 : index;
  };

  document.querySelectorAll('.product-youtube-embed__thumb').forEach((img) => {
    const videoId = img.dataset.videoId;
    if (!videoId) return;

    let qualityIndex = getQualityIndex(img.dataset.thumbQuality);

    img.addEventListener('error', () => {
      qualityIndex += 1;
      if (qualityIndex >= THUMB_QUALITIES.length) return;

      img.dataset.thumbQuality = THUMB_QUALITIES[qualityIndex];
      img.src = `https://i.ytimg.com/vi/${videoId}/${THUMB_QUALITIES[qualityIndex]}.jpg`;
    });
  });

  document.querySelectorAll('.product-youtube-embed__media').forEach((media) => {
    media.addEventListener('click', () => {
      media.closest('.product-youtube-embed')?.classList.add('is-playing');
    });
  });
})();
